import { apiWithoutAuth, xmlParser } from '@/shared';

import { newsPaths } from './paths';

import type { MkItem, CointelgraphItem, XmlParseFormat, PressItem, ServerNewsListResponse, NewsSearchResponse } from '@/entities/news/types';

export const getMkRss = async () => {
  const response = await apiWithoutAuth.get(newsPaths.getMkNews);

  return xmlParser.parse(response.data) as XmlParseFormat<MkItem>;
};

export const getCointelegraphRss = async () => {
  const response = await apiWithoutAuth.get(newsPaths.getCointelegraph);

  return xmlParser.parse(response.data) as XmlParseFormat<CointelgraphItem>;
};

export const getCoindeskRss = async () => {
  const response = await apiWithoutAuth.get(newsPaths.getCoindeskNews);

  return xmlParser.parse(response.data) as XmlParseFormat<CointelgraphItem>;
};

export const getPressList = async (category?: string): Promise<PressItem[]> => {
  const { data } = category
    ? await apiWithoutAuth.get(newsPaths.pressList, { params: { category } })
    : await apiWithoutAuth.get(newsPaths.pressList);
  return data.result.pressList;
};

export const getNewsByMedia = async (media: string): Promise<ServerNewsListResponse> => {
  const { data } = await apiWithoutAuth.get(newsPaths.newsList, {
    params: { media },
  });
  return data.result;
};

export const getNewsByCategory = async (category: string): Promise<ServerNewsListResponse> => {
  const params: Record<string, string> = {};
  if (category) params.category = category;
  const { data } = await apiWithoutAuth.get(newsPaths.newsList, { params });
  return data.result;
};

export const searchNews = async (
  query: string,
  start: number = 1,
  display: number = 20,
): Promise<NewsSearchResponse> => {
  const { data } = await apiWithoutAuth.get(newsPaths.newsSearch, {
    params: { query, start, display },
  });
  return data.result;
};
